var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-light-modal u-box-shadow",style:({
    background: _vm.bg,
    position: _vm.fixed ? 'fixed' : 'absolute',
    top: _vm.top ? _vm.top + 'px' : '30px',
  })},[_c('div',{staticClass:"o-light-modal__cover",on:{"click":_vm.hide}}),_c('div',{staticClass:"o-light-modal__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }